import { Button, Form, Radio, Select, Table } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { useEffect, useState } from 'react';

import cronTime from 'cron-time-generator';
import { MinusCircleOutlined } from '@ant-design/icons';

interface ScheduleForm {
  value?: string;
  sendType?: string;
}

const getScheduleTableData = (scheduleArray: ScheduleForm[]) => {
  const data = [] as any;

  scheduleArray?.forEach(schedule => {
    if (schedule.value) {
      const scheduleChars = schedule.value.split(' ');

      let frequency: string | undefined = undefined;
      let day: string | undefined = undefined;
      let hour: string | undefined = undefined;
      let hourInterval: string | undefined = undefined;
      let minuteInterval: string | undefined = undefined;
      let description: string | undefined = undefined;
      if (scheduleChars[4] !== '*') {
        frequency = 'w';
      } else if (scheduleChars[1].indexOf('/') > -1 || schedule.value === '0 * * * *') {
        frequency = 'd';
      } else if (scheduleChars[0].indexOf('/') > -1 || schedule.value === '* * * * *') {
        frequency = 's';
      } else {
        frequency = 'm';
      }

      if (frequency === 'm') {
        day = scheduleChars[2];
        hour = scheduleChars[1];
        description = `Her ayın ${day}. günü saat ${hour.padStart(2, '0')}:00`;
      } else if (frequency === 'w') {
        day = scheduleChars[4];
        hour = scheduleChars[1];
        description = `Her haftanın ${day}. günü saat ${hour.padStart(2, '0')}:00`;
      } else if (frequency === 'd') {
        if (schedule.value === '0 * * * *') {
          hourInterval = '1';
          description = 'Her saat başı';
        } else {
          hourInterval = scheduleChars[1].split('/')[1];
          description = `Her ${hourInterval} saatte bir`;
        }
      } else if (frequency === 's') {
        minuteInterval = scheduleChars[0].split('/')[1];
        if (!minuteInterval) {
          description = 'Dakikada bir';
        } else {
          description = `Her ${minuteInterval} dakikada bir`;
        }
      } else {
        frequency = 'n';
        description = 'Yok';
      }

      data.push({
        key: Math.floor(Math.random() * 10000),
        schedule: schedule.value,
        frequency,
        frequencyText:
          frequency === 'm'
            ? 'Aylık'
            : frequency === 'w'
            ? 'Haftalık'
            : frequency === 'd'
            ? 'Günlük'
            : frequency === 's'
            ? 'Saatlik'
            : 'Yok',
        day,
        hour: hour ? (hour.length > 1 ? hour : '0' + hour) + ':00' : undefined,
        sendType: schedule.sendType,
        sendTypeText: schedule.sendType === 'all' ? 'Tüm Kayıtlar' : 'Değişen kayıtlar',
        hourInterval,
        minuteInterval,
        description,
      });
    }
  });

  return data;
};

export function IntegrationSchedulesForm(props: {
  value?: string[];
  integrationType: string;
  onChange?: (cronString: string[]) => void;
  onFinish?: (tableData: any[]) => void;
}) {
  const { Option } = Select;

  const [form] = useForm();
  const [formValues, setFormValues] = useState<any>();
  const [tableData, setTableData] = useState([] as any);
  const [frequency, setFrequency] = useState('n');

  let tableColumns = [
    {
      title: 'Açıklama',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: 'Gönderim Tipi',
      dataIndex: 'sendTypeText',
      key: 'sendTypeText',
    },
    {
      title: '',
      key: 'action',
      render: (text: any, record: any) => (
        <Button
          type="link"
          onClick={() => {
            const newTableData = tableData.filter((d: any) => d.key !== record.key);
            setTableData(newTableData);
            props.onChange?.(
              newTableData.map((d: any) => {
                return { value: d.schedule, sendType: d.sendType };
              }),
            );
          }}
        >
          <MinusCircleOutlined style={{ marginLeft: '0.5rem' }} />
        </Button>
      ),
    },
  ];

  if (props.integrationType !== 'export') {
    tableColumns = tableColumns.filter(c => c.dataIndex !== 'sendTypeText');
  }

  const weekDays = [
    { value: '1', name: 'Pazartesi' },
    { value: '2', name: 'Salı' },
    { value: '3', name: 'Çarşamba' },
    { value: '4', name: 'Perşembe' },
    { value: '5', name: 'Cuma' },
    { value: '6', name: 'Cumartesi' },
    { value: '7', name: 'Pazar' },
  ];
  const monthDays = [
    { value: '1', name: '01' },
    { value: '2', name: '02' },
    { value: '3', name: '03' },
    { value: '4', name: '04' },
    { value: '5', name: '05' },
    { value: '6', name: '06' },
    { value: '7', name: '07' },
    { value: '8', name: '08' },
    { value: '9', name: '09' },
    { value: '10', name: '10' },
    { value: '11', name: '11' },
    { value: '12', name: '12' },
    { value: '13', name: '13' },
    { value: '14', name: '14' },
    { value: '15', name: '15' },
    { value: '16', name: '16' },
    { value: '17', name: '17' },
    { value: '18', name: '18' },
    { value: '19', name: '19' },
    { value: '20', name: '20' },
    { value: '21', name: '21' },
    { value: '22', name: '22' },
    { value: '23', name: '23' },
    { value: '24', name: '24' },
    { value: '25', name: '25' },
    { value: '26', name: '26' },
    { value: '27', name: '27' },
    { value: '28', name: '28' },
    { value: '29', name: '29' },
    { value: '30', name: '30' },
    { value: '31', name: '31' },
  ];
  const hours = [
    '00:00',
    '01:00',
    '02:00',
    '03:00',
    '04:00',
    '05:00',
    '06:00',
    '07:00',
    '08:00',
    '09:00',
    '10:00',
    '11:00',
    '12:00',
    '13:00',
    '14:00',
    '15:00',
    '16:00',
    '17:00',
    '18:00',
    '19:00',
    '20:00',
    '21:00',
    '22:00',
    '23:00',
  ];
  const hourIntervals = ['1', '2', '3', '4', '6', '8', '12'];
  const minuteIntervals = ['1', '2', '3', '4', '5', '10', '15', '20', '30', '45'];

  useEffect(() => {
    const value: any = props.value;
    if (value) {
      const data = getScheduleTableData(value);
      setTableData(data);
    }
    setFormValues({ frequency: 'd' });
    setFrequency('d');
  }, [props.value]);

  const onFrequencyChange = (e: any) => {
    const newFrequency = e.target.value;
    setFrequency(newFrequency);
    form.setFieldsValue({
      day: undefined,
      hour: undefined,
      hourInterval: undefined,
      minuteInterval: undefined,
    });
  };

  const onFinish = (values: any) => {
    let schedule: string | null = null;
    if (values.frequency === 'm') {
      const day = parseInt(values.day);
      const hour = parseInt(values.hour.split(':')[0]);
      const minute = parseInt(values.hour.split(':')[1]);
      schedule = cronTime.everyMonthOn(day, hour, minute);
    } else if (values.frequency === 'w') {
      const day = parseInt(values.day);
      const hour = parseInt(values.hour.split(':')[0]);
      const minute = parseInt(values.hour.split(':')[1]);
      schedule = cronTime.onSpecificDaysAt([day], hour, minute);
    } else if (values.frequency === 'd') {
      const hourInterval = parseInt(values.hourInterval);
      schedule = cronTime.every(hourInterval).hours();
    } else if (values.frequency === 's') {
      const minuteInterval = parseInt(values.minuteInterval);
      schedule = cronTime.every(minuteInterval).minutes();
    }

    const newTableData = getScheduleTableData([
      { value: schedule, sendType: values.sendType },
      ...tableData.map((d: any) => {
        return { value: d.schedule, sendType: d.sendType };
      }),
    ]);
    setTableData(newTableData);
    props.onChange?.(
      newTableData.map((d: any) => {
        return { value: d.schedule, sendType: d.sendType };
      }),
    );
  };

  const addToList = () => {
    form
      .validateFields()
      .then(() => {
        form.submit();
      })
      .catch(() => {});
  };

  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
        gap: '4rem',
      }}
    >
      <div
        style={{
          flex: 2,
        }}
      >
        {formValues && (
          <Form layout="vertical" form={form} onFinish={onFinish} initialValues={formValues}>
            <Form.Item name="frequency" label="Aktarım sıklığı" rules={[{ required: true, message: 'Zorunlu alan' }]}>
              <Radio.Group buttonStyle="solid" onChange={onFrequencyChange}>
                <Radio.Button value="m">Aylık</Radio.Button>
                <Radio.Button value="w">Haftalık</Radio.Button>
                <Radio.Button value="d">Günlük</Radio.Button>
                <Radio.Button value="s">Saatlik</Radio.Button>
              </Radio.Group>
            </Form.Item>
            {(frequency === 'w' || frequency === 'm') && (
              <Form.Item label="Gün" name="day" rules={[{ required: true, message: 'Zorunlu alan' }]}>
                <Select>
                  {(frequency === 'w' ? weekDays : monthDays).map(d => (
                    <Option key={d.value} value={d.value}>
                      {d.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            )}
            {frequency !== 'n' && frequency !== 'd' && frequency !== 's' && (
              <Form.Item label="Saat" name="hour" rules={[{ required: true, message: 'Zorunlu alan' }]}>
                <Select>
                  {hours.map(h => (
                    <Option key={h} value={h}>
                      {h}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            )}
            {frequency === 'd' && (
              <Form.Item label="Saat aralığı" name="hourInterval" rules={[{ required: true, message: 'Zorunlu alan' }]}>
                <Select>
                  {hourIntervals.map(h => (
                    <Option key={h} value={h}>
                      {h}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            )}
            {frequency === 's' && (
              <Form.Item label="Dakika aralığı" name="minuteInterval" rules={[{ required: true, message: 'Zorunlu alan' }]}>
                <Select>
                  {minuteIntervals.map(h => (
                    <Option key={h} value={h}>
                      {h}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            )}
            {props.integrationType === 'export' && (
              <Form.Item name="sendType" label="Gönderim Tipi" rules={[{ required: true, message: 'Zorunlu alan' }]}>
                <Select>
                  <Option value="all">Tüm Kayıtlar</Option>
                  <Option value="changed">Değişen kayıtlar</Option>
                </Select>
              </Form.Item>
            )}
            <Form.Item>
              <Button htmlType="button" onClick={addToList}>
                Ekle
              </Button>
            </Form.Item>
          </Form>
        )}
      </div>

      <div style={{ flex: 3 }}>
        <Table columns={tableColumns} dataSource={tableData} pagination={false} size="small" />
      </div>
    </div>
  );
}
